import React from 'react';
import { InputGroup } from 'react-bootstrap';
import { Field } from 'formik';
import PropTypes from 'prop-types';

export const CoveredSurface = ({ errors, touched }) => (
  <div>
    <label>Superficie cubierta *</label>
    <InputGroup size="sm" className="formWidths" style={{ maxWidth: '150px' }}>
      <InputGroup.Text id="basic-addon1">m2</InputGroup.Text>
      <Field className="form-control" name="surface.coveredSurface" />
    </InputGroup>
    {errors.surface?.coveredSurface && touched.surface?.coveredSurface && (
      <label className="w-100 text-danger mt-1">
        {errors.surface.coveredSurface}
      </label>
    )}
  </div>
);

CoveredSurface.propTypes = {
  errors: PropTypes.object,
  touched: PropTypes.object
};
